module.exports = __webpack_public_path__ + "img/portal-samp-list.97ea365e.jpg";